import translations from './ListingDetailsDrawer.translations'
import Alerts from './components/Tabs/Alerts/Alerts.vue'
import Comments from './components/Tabs/Comments/Comments.vue'
import PricingInsights from './components/Tabs/PricingInsights/PricingInsights.vue'
import ProductSpecifications from './components/Tabs/ProductSpecifications/ProductSpecifications.vue'
import Shipping from './components/Tabs/Shipping/Shipping.vue'
import SimilarListings from './components/Tabs/SimilarListings/SimilarListings.vue'

export const QUERY_MODAL_NAME = 'm-listing-id'
export const QUERY_MODAL_TAB_NAME = 'm-listing-tab'

export const TABS_INFO = [
  {
    component: Alerts,
    tabName: 'alerts',
    translationKey: translations.alertsTabLabel,
  },
  {
    component: Comments,
    tabName: 'comments',
    translationKey: translations.commentsTabLabel,
  },
  {
    component: Shipping,
    tabName: 'shipping',
    translationKey: translations.shippingTabLabel,
  },
  {
    component: ProductSpecifications,
    tabName: 'product-specifications',
    translationKey: translations.productSpecificationsTabLabel,
  },
  {
    component: SimilarListings,
    tabName: 'similar-listings',
    translationKey: translations.similarListingsTabLabel,
  },
  {
    component: PricingInsights,
    tabName: 'pricing-insights',
    translationKey: translations.pricingInsightsTabLabel,
  },
]

export const MODAL_NAME = 'listings.detail'
